var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":_vm.icon,"custom-class":_vm.spin ? 'fa-spin' : '',"size":_vm.size}})],1),(typeof _vm.text === 'undefined')?_c('p',{directives:[{name:"t",rawName:"v-t",value:('loading'),expression:"'loading'"}]}):_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }